export default __webpack_public_path__ + "static/media/PPI-garden-bed-005.fef2d001.jpg";